<template>
  <!--我的账单详情-->
  <div class="" v-loading>
    <div class="independent-container__box">
      <div class="independent-container__title">委托信息</div>
      <el-row>
        <el-col class="info__box" :span="8">
          <div class="info__label">运单号</div>
          <div class="info__container">
            {{baseInfo.innos}}
          </div>
        </el-col>
        <el-col class="info__box" :span="8">
          <div class="info__label">专线渠道名称</div>
          <div class="info__container">
            {{baseInfo.productName}}
          </div>
        </el-col>
        <el-col class="info__box" :span="8">
          <div class="info__label">运输方式</div>
          <div class="info__container">
            {{baseInfo.transportType}}
          </div>
        </el-col>
        <el-col class="info__box" :span="8">
          <div class="info__label">{{ baseInfo.transportType && transportNameMapping[baseInfo.transportType] || '运输' }}公司</div>
          <div class="info__container">
            <template v-if="baseInfo.transportType === '海运'">
              {{ baseInfo.shipCompanyNames || '-' }}
            </template>
            <template v-else-if="baseInfo.transportType === '空运'">
              {{ baseInfo.airCompanyNames || '-' }}
            </template>
            <template v-else-if="baseInfo.transportType === '陆运'">
              {{ baseInfo.landCompanyNames || '-' }}
            </template>
            <template v-else>-</template>
          </div>
        </el-col>
        <el-col class="info__box" :span="8">
          <div class="info__label">派送方式</div>
          <div class="info__container">
            {{ baseInfo.deliveryTypeName || '-' }}
            <template v-if="baseInfo.deliverySecond || baseInfo.deliverySeconds">
              -{{ baseInfo.deliverySeconds || baseInfo.deliverySecond }}
            </template>
          </div>
        </el-col>
        <div class="clear-both"></div>

        <el-col class="info__box" :span="8">
          <div class="info__label">主单号</div>
          <div class="info__container">
            {{baseInfo.orderNo}}
          </div>
        </el-col>
        <el-col class="info__box" :span="8">
          <div class="info__label">下单时间</div>
          <div class="info__container">
            {{baseInfo.inputtime}}
          </div>
        </el-col>

      </el-row>
    </div>
    <div class="independent-container__box">
      <div class="independent-container__title">收发货信息</div>
      <el-row>
        <el-col class="info__box" :span="12">
          <div class="info__label">发货仓</div>
          <div class="info__container">
            {{shipperAndReceivingInfo.transferWarehouse}}
          </div>
        </el-col>
        <el-col class="info__box" :span="12">
          <div class="info__label">收货国家</div>
          <div class="info__container">
            {{shipperAndReceivingInfo.recGoodsCountry}}
          </div>
        </el-col>
        <el-col class="info__box" :span="12">
          <div class="info__label">发货仓地址</div>
          <div class="info__container">
            {{shipperAndReceivingInfo.transferWarehouseAddr}}
          </div>
        </el-col>
        <el-col class="info__box" :span="12">
          <div class="info__label">收货仓库</div>
          <div class="info__container">
            {{shipperAndReceivingInfo.recWarehouseCode}}
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="flex" style="justify-content: space-between;">
      <div class="independent-container__box" style="width: 49%;">
        <div class="independent-container__border-header">商品预报信息</div>
        <div class="" style="margin: 0 -15px;">
          <div class="table__border--header">预报单商品详情</div>
          <el-table :data="preBoxInfos"
                    size="mini"
                    border
                    max-height="300"
                    :header-cell-style="{ background: '#F3F3F3' }">
            <el-table-column label="货代拼箱号" prop="citiBoxNo"></el-table-column>
            <el-table-column label="货物类型" prop="goodsType"></el-table-column>
            <el-table-column label="长(cm)" prop="length"></el-table-column>
            <el-table-column label="宽(cm)" prop="width"></el-table-column>
            <el-table-column label="高(cm)" prop="height"></el-table-column>
            <el-table-column label="重量(kg)" prop="weight"></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-popover placement="top"
                            width="1000"
                            trigger="hover">
                  <el-table :data="scope.row.goodsList||[]">
                    <el-table-column  label="中文名" width="100px">
                      <template slot-scope="scope">
                        {{scope.row.goodsnamec || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="英文名">
                      <template slot-scope="scope">
                        {{scope.row.goodsnamee || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="商品类型" prop="">
                      <template slot-scope="scope">
                        {{scope.row.goodstype || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="数量" prop="">
                      <template slot-scope="scope">
                        {{scope.row.piece || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="型号" prop="">
                      <template slot-scope="scope">
                        {{scope.row.model || "-"}}
                      </template>
                    </el-table-column>

                    <el-table-column  label="品牌" prop="">
                      <template slot-scope="scope">
                        {{scope.row.brand || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="货值" prop="">
                      <template slot-scope="scope">
                        {{scope.row.price || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="海关编号" prop="">
                      <template slot-scope="scope">
                        {{scope.row.hsCode || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="材质" prop="">
                      <template slot-scope="scope">
                        {{scope.row.materialc||'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="用途" prop="">
                      <template slot-scope="scope">
                        {{scope.row.purposec||'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="带电" prop="">
                      <template slot-scope="scope">
                        {{scope.row.isHasBattery === true ? '是' :  scope.row.isHasBattery === false ? "否" : "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="带磁" prop="">
                      <template slot-scope="scope">
                        {{scope.row.isHasMagnetic === true ? '是' :  scope.row.isHasMagnetic === false ? "否" : "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="液体/粉末" prop="">
                      <template slot-scope="scope">
                        {{scope.row.isPowderLiquid === true ? '是' :  scope.row.isPowderLiquid === false ? "否" : "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="销售链接" prop="">
                      <template slot-scope="scope">
                        {{scope.row.salesUrl || '-'}}
                      </template>
                    </el-table-column>
                  </el-table>

                  <el-link type="success" slot="reference">查看</el-link>
                </el-popover>

              </template>
            </el-table-column>
          </el-table>

          <div class="table__border--header" style="margin-top: 30px;">预报单增值服务详情</div>
          <el-table :data="preFeeDTO.feeList"
                    size="mini"
                    border
                    max-height="300"
                    :header-cell-style="{ background: '#F3F3F3' }">
            <el-table-column label="服务名称" prop="feeCode">
              <template slot-scope="scope">
                {{addedServiceListMapObject[scope.row.feeCode] || scope.row.feeCode }}
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="piece"></el-table-column>
            <el-table-column label="单价" prop="price"></el-table-column>
            <el-table-column label="币种" prop="currency"></el-table-column>
            <el-table-column label="计算过程" prop="calDesc"></el-table-column>
            <el-table-column label="总价" prop="amount"></el-table-column>
          </el-table>
<!--          <div class="info__box">-->
<!--            <div class="info__label">合计费用：</div>-->
<!--            <div class="info__container">-->
<!--              {{preFeeDTO.totalAmount}}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="info__box">-->
<!--            <div class="info__label">折合人民币：</div>-->
<!--            <div class="info__container">-->
<!--              {{preFeeDTO.totalCnyAmount}}-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="independent-container__box" style="width: 49%;">
        <div class="independent-container__border-header">
          专线入仓信息
          <div>
            <el-button @click="exportToExcel">导出预报信息</el-button>
            <el-button type="primary" @click="visibleUploadDialog = true" v-if="canUpload">导入</el-button>
          </div>
        </div>
        <div class="" style="margin: 0 -15px;">
          <div class="table__border--header">入仓商品详情</div>
          <el-table :data="boxInfo"
                    size="mini"
                    border
                    ref="boxInfo"
                    :header-cell-style="{ background: '#F3F3F3' }">
            <el-table-column label="货代拼箱号" prop="citiBoxNo" ></el-table-column>
            <el-table-column label="货物类型" prop="goodsType" ></el-table-column>
            <el-table-column label="长" prop="length" width="120"></el-table-column>
            <el-table-column label="宽" prop="width" width="120"></el-table-column>
            <el-table-column label="高" prop="height" width="120"></el-table-column>
            <el-table-column label="重量(kg)" prop="weight" width="120"></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-popover placement="top"
                            width="1000"
                            trigger="hover">
                  <el-table :data="scope.row.goodsList||[]">
                    <el-table-column  label="中文名" width="100px">
                      <template slot-scope="scope">
                        {{scope.row.goodsnamec || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="英文名">
                      <template slot-scope="scope">
                        {{scope.row.goodsnamee || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="商品类型" prop="">
                      <template slot-scope="scope">
                        {{scope.row.goodstype || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="数量" prop="">
                      <template slot-scope="scope">
                        {{scope.row.piece || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="型号" prop="">
                      <template slot-scope="scope">
                        {{scope.row.model || "-"}}
                      </template>
                    </el-table-column>

                    <el-table-column  label="品牌" prop="">
                      <template slot-scope="scope">
                        {{scope.row.brand || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="货值" prop="">
                      <template slot-scope="scope">
                        {{scope.row.price || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="海关编号" prop="">
                      <template slot-scope="scope">
                        {{scope.row.hsCode || "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="材质" prop="">
                      <template slot-scope="scope">
                        {{scope.row.materialc||'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="用途" prop="">
                      <template slot-scope="scope">
                        {{scope.row.purposec||'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="带电" prop="">
                      <template slot-scope="scope">
                        {{scope.row.isHasBattery === true ? '是' :  scope.row.isHasBattery === false ? "否" : "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="带磁" prop="">
                      <template slot-scope="scope">
                        {{scope.row.isHasMagnetic === true ? '是' :  scope.row.isHasMagnetic === false ? "否" : "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="液体/粉末" prop="">
                      <template slot-scope="scope">
                        {{scope.row.isPowderLiquid === true ? '是' :  scope.row.isPowderLiquid === false ? "否" : "-"}}
                      </template>
                    </el-table-column>
                    <el-table-column  label="销售链接" prop="">
                      <template slot-scope="scope">
                        {{scope.row.salesUrl || '-'}}
                      </template>
                    </el-table-column>
                  </el-table>

                  <el-link type="success" slot="reference">查看</el-link>
                </el-popover>

              </template>
            </el-table-column>
          </el-table>
          <div style="text-align:center;">
            <el-button type="primary" style="margin-top: 10px" @click="saveMeasureInfo" v-if="canUpload">保存</el-button>
            <el-button type="primary" style="margin-top: 10px" @click="getMeasureInfo" v-if="canUpload">获取实测数据</el-button>
          </div>

<!--          <div class="table__border&#45;&#45;header" style="margin-top: 30px;">增值服务详情</div>-->
<!--          <el-table :data="confirmFeeDTO.feeList"-->
<!--                    size="mini"-->
<!--                    border-->
<!--                    max-height="300"-->
<!--                    :header-cell-style="{ background: '#F3F3F3' }">-->
<!--            <el-table-column label="服务名称" prop="feeCode">-->
<!--              <template slot-scope="scope">-->
<!--                {{addedServiceListMapObject[scope.row.feeCode] || scope.row.feeCode }}-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="数量" prop="piece"></el-table-column>-->
<!--            <el-table-column label="单价" prop="price"></el-table-column>-->
<!--            <el-table-column label="币种" prop="currency"></el-table-column>-->
<!--            <el-table-column label="计算过程" prop="calDesc"></el-table-column>-->
<!--            <el-table-column label="总价" prop="amount"></el-table-column>-->
<!--          </el-table>-->
<!--          <div class="info__box">-->
<!--            <div class="info__label">合计费用：</div>-->
<!--            <div class="info__container">-->
<!--              {{confirmFeeDTO.totalAmount}}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="info__box">-->
<!--            <div class="info__label">折合人民币：</div>-->
<!--            <div class="info__container">-->
<!--              {{confirmFeeDTO.totalCnyAmount}}-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="margin-tb-sm"
         style="text-align: center">
      <el-button type=""
                 icon="el-icon-back"
                 style="margin-top:40px;min-width: 120px;"
                 @click="$router.back()">返回</el-button>
    </div>

    <el-dialog title=""
               width="760px"
               custom-class="edit-dialog"
               :visible.sync="visibleUploadDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <el-upload class="upload-demo margin-bottom"
                 style="text-align: center"
                 :show-file-list="false"
                 :headers="uploadHeader"
                 :on-error="handleError"
                 :on-success="handleSuccess"
                 :before-upload="handleBeforeUpload"
                 :action="upUrl"
                 drag
                 multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅限xls和xlsx文件</div>
      </el-upload>
      <el-table :data="tableDataUpload"
                v-show="tableDataUpload.length > 0"
                size="mini"
                align="center"
                border
                max-height="400px"
                style="width: 100%"
      >
        <el-table-column label="序号"
                         width="50"
                         type="index"></el-table-column>
        <el-table-column label="单号"
                         min-width="150"
                         prop="comId"></el-table-column>
        <el-table-column label="状态"
                         width="100"
                         prop="failureReason">
          <template slot-scope="scope">
            <span :class="[scope.row.isSuccess?'color-success':'color-danger']">{{ scope.row.isSuccess?'成功':'失败' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="错误描述"
                         min-width="200"
                         prop="">
          <template slot-scope="scope">
            <span :class="[scope.row.isSuccess?'color-success':'color-danger']">{{ scope.row.failureReason }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center;">
        <el-button @click="hideUploadDialog"
                   style="margin-right: 20px"
                   size="mini">取 消</el-button>
        <el-link type="success" @click="downTemplate">
          <el-button size="mini"
                     type="success">下载模板</el-button>
        </el-link>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapFromArrayToObject} from "@/assets/js/utils";
import {baseDataAddedServiceList} from "@/components/QuotationManagement/components-productQuotation/productQuotation";

export default {
    name: "platformBeforeOrderDetails",
    data() {
      return {
        id:'',
        details:{},
        addedServiceListMapObject:mapFromArrayToObject(baseDataAddedServiceList(),{label: 'name', value: 'code'}),
        visibleUploadDialog: false,
        tableDataUpload: [],
        downUrl: '',
        upUrl: '/api/carrier/order/execlMeasureInfo',// 上传模板地址
        uploadHeader:{token:''},
        transportNameMapping: {
          '空运': '航空',
          '海运': '船运',
          '陆运': '陆运'
        }
      }
    },
    created(value) {
      let id = this.id = this.$route.query.id;
      this.getFBAHeaderOrderDetails();
      this.uploadHeader.token = this.$store.state.Authorization.token;
    },
    methods:{
      /**
       * 获取 详情
       */
      getFBAHeaderOrderDetails(id = this.id) {
        if(!id) return this.$message.error('ID为空');
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.get('/carrier/order/getFirstLegOrderInfo/'+id)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.info(res.data.message || "获取列表：服务器繁忙");
                return false;
              }
              this.details = res.data.data;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
            });
        });
      },
      hideUploadDialog() {
        this.visibleUploadDialog = false
      },
      /*上传*/
      handleBeforeUpload(file) {
        // 校验
        let legalName = ["xlsx", "xls"];
        // 拿到后缀名
        let name = file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
        if (legalName.includes(name)) {
          console.log(legalName.includes(name));
        } else {
          this.$message.info("文件格式不对，仅限xls和xlsx");
          return false;
        }
      },
      handleError(err) {
        this.$message.info(err.data);
      },
      handleSuccess(res) {
        if (typeof res === 'string') {
          this.$message.info(res);
          return false;
        }
        //  console.log(response);
        if (res.code !== 200) {
          this.$message.info(res.message);
          return false;
        }
        this.$message.success("上传成功");
        let list = res.datas || []
        list.forEach(item => {
          const box = this.preBoxInfos.find(_item => item.citiBoxNo === _item.citiBoxNo)
          if (box) item.goodsList = box.goodsList
        })
        this.details.boxInfo = list
        this.hideUploadDialog()
      },
      saveMeasureInfo() {
        let list = this.boxInfo.map(item => {
          return {
            cbm: item.cbm,
            citiBoxNo: item.citiBoxNo,
            fbxBoxNo: item.fbxBoxNo,
            height: item.height,
            length: item.length,
            weight: item.weight,
            width: item.width
          }
        })
        let params = {
          measureInfoDTOs: list,
          nos: this.baseInfo.innos
        }
        this.axios.post('/api/carrier/order/saveExeclMeasureInfo', params).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            this.$message.success(res.data.message)
          }
        })
      },
      exportToExcel() {
        require.ensure([], () => {
          // eslint-disable-next-line camelcase
          const { export_json_to_excel } = require('../../assets/js/export2-excel') // 注意这个是Export2Excel路径
          const tHeader = ['货代拼箱号', '货物类型', '长', '宽', '高', '重量'] // 上面设置Excel的表格第一行的标题
          const filterVal = ['citiBoxNo','goodsType', 'length', 'width', 'height', 'weight']// 上面是tableData里对象的属性key值

          const table = JSON.parse(JSON.stringify(this.preBoxInfos))

          const data = this.formatJson(filterVal.filter((item) => item !== undefined), table)

          export_json_to_excel(tHeader.filter((item) => item !== undefined), data, '入仓测量信息模板') // 最后一个是表名字
        })
      },
      formatJson (filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (v[j] !== undefined) {
            return v[j]
          }
        }))
      },
      downTemplate() {
        this.exportToExcel()
      },
      getMeasureInfo() {
        let url = '/erp/pre/fba/getMeasureInfo'
        let host = window.location.host
        let baseUrl = ''
        if (/qa2/.test(host)) {
          baseUrl = 'http://erp.qa2.huodaipin.com.cn'
        } else if (/uat/.test(host)) {
          baseUrl = 'http://erp.uat.huodaipin.com.cn'
        } else if (/localhost/.test(host)) {
          baseUrl = 'http://erp.uat.huodaipin.com.cn'
        } else {
          baseUrl = 'https://erp.huodaipin.com'
        }
        this.axios.get(`${url}?innos=${this.baseInfo.innos}`,{baseURL: baseUrl})
          .then(res => {
            if (res.data.code === 1) {
              console.log(res.data.data)
              let box = res.data.data.boxInfos
              box.forEach(item => {
                item.citiBoxNo = item.boxNo
                const box = this.preBoxInfos.find(_item => item.citiBoxNo === _item.citiBoxNo)
                if (box) item.goodsList = box.goodsList
              })
              this.details.boxInfo = box
            } else {
              this.$message.error('暂无实测数据')
            }
          })
      }
    },
    computed:{
      //委托信息
      baseInfo(){
        return this.details.baseInfo ||{};
      },
      // 收发货信息
      shipperAndReceivingInfo(){
        return this.details.shipperAndReceivingInfo ||{};
      },
      // 预报商品详情
      preBoxInfos(){
        let target = this.details.preBoxInfos||[];
        return target;
      },
      // 预报增值服务
      preFeeDTO(){
        let target = this.details.preFeeDTO||{};
        if(!target.feeList) target.feeList = [];
        return target;
      },
      // 已入仓商品详情
      boxInfo(){
        let target = this.details.boxInfo;
        // if(target){
        //   target = [target];
        // }else{
        //   target = []
        // }
        return target;
      },
      // 已入仓增值服务
      confirmFeeDTO(){
        let target = this.details.confirmFeeDTO ||{};
        if(!target.feeList) target.feeList = [];
        return target;
      },
      state() {
        return this.$route.query.state
      },
      supplierSetting() {
        return this.$store.state.Authorization.supplierSettingDTO
      },
      // 判断是否可以对接，未对接才能上传测量入仓信息
      canUpload() {
        if (!this.supplierSetting) return true
        if (!this.supplierSetting.setIsConnected) return true
        if (!this.supplierSetting.setWhetherPushOrder) return true
        return false
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderManagement/FBAHeaderDetails.vue